<div class="section-header__heading">
  <span class="section-header__accent" aria-hidden="true"></span>
  <div class="section-header__text">
    <h2>{{ title }}</h2>
    <ng-content select="[section-header-description]"></ng-content>
  </div>
</div>

<div class="section-header__content">
  <ng-content></ng-content>
</div>
